import { stringify } from 'qs';
import { message } from 'antd';

const STRINGIFY_OPTIONS = {
  format: 'RFC1738',
  addQueryPrefix: true,
  sort: (a, b) => (a.localeCompare(b)),
};

// Searches the organization's assignable users, for the single-record and bulk
// assign modals both. /api/v1/department_users returns [email, name] pairs -- note
// the order -- so the option VALUE is the email the assign endpoints look up by.
//
// The options come off this response rather than out of redux: the thunk puts them
// there too, but a hook-based caller has not necessarily re-rendered by the time
// the await resolves, which showed up as an empty picker.
export const fetchAssigneeOptions = async ({ value, getUserDepartmentsByQuery }) => {
  const query = { contains: value || undefined, page: 1 };
  const response = await getUserDepartmentsByQuery(stringify(query, STRINGIFY_OPTIONS));
  const users = response?.data?.users || [];

  if (users.length === 0) message.error({ content: 'No users found in your organization' });

  return users.map((user) => ({ label: user[1], value: user[0] }));
};

export default fetchAssigneeOptions;
